export const SET_ACTIVE_CONTENT_ID = "SET_ACTIVE_CONTENT_ID";
export const CLOSE_CONTENT_PANEL = "CLOSE_CONTENT_PANEL";
export const SET_ACTIVE_TAB_KEY = "SET_ACTIVE_TAB_KEY";
